@import "../../sass/variables/variables";

.ux-notification-text {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.ux-notification-text__wrapper_expanded {
  max-height: unset !important;
  overflow: unset !important;
}

.ux-notification-text__wrapper_gradient::before {
  content: "";
  width: 100%;
  height: 114px;
  @media (min-width: $bp-xl) {
    height: 150px;
  }
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
}

.ux-notification-text__icon {
  transform: rotate(180deg);
}

.ux-notification-text__wrapper {
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  max-height: 114px;
  @media (min-width: $bp-xl) {
    max-height: 150px;
  }
  overflow: hidden;

  .ux-notification-text__error {
    @include font(light);

    color: $color-red-error;
    font-size: $size-text-small;
    margin-bottom: 5px;
    text-transform: uppercase;
  }

  .ux-notification-text__subject {
    margin-bottom: 4px;
    @media (min-width: $bp-xl) {
      margin-bottom: 6px;
    }
  }

  .ux-notification-text__message {
    color: var(--ux-notification-item-text-color);

    .ux-text-link {
      white-space: nowrap;
    }
  }
}

// Severity modifier
.ux-notification-item--information {
  .ux-notification-text__subject {
    color: $color-black;
  }
}

.ux-notification-item--warning {
  .ux-notification-text__subject {
    color: $color-orange;
  }
}

.ux-notification-item--error {
  .ux-notification-text__subject {
    color: $color-red;
  }
}
